import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../../../Components/MainLayout/Header";
import { Link } from "react-router-dom";
import noData from "../../../Assets/img/noData.png";
// import Axios from "axios";
import Skeleton from "react-loading-skeleton";
import LeaveCard from "../../../Components/Leave/LeaveCard";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class PreviousLeave extends Component {
  state = { data: [], loading: false, fakeData: [1, 2, 3] };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Leave";
  }

  render() {
    const fakeData = [0, 1, 2, 3, 4, 5];

    return (
      <div>
        <Header to="/home" title="Leave" />
        <div className="d-flex flex-row th-no-scroll pt-2">
          <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
            <div className="th-primary">Previous</div>
            <hr
              className="w-100 my-1 th-border"
              style={{ borderWidth: 5, borderRadius: 5 }}
            />
          </div>
          <Link style={{ textDecoration: "none" }} to="/newLeave">
            <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
              <div className="th-black">Apply New</div>
            </div>
          </Link>
        </div>

        <div className="container">
          {this.state.loading
            ? fakeData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="border p-3 shadow-sm rounded-lg mb-3"
                  >
                    <Skeleton />
                    <Skeleton width={200} />
                  </div>
                );
              })
            : null}

          {fakeData.length !== 0 && this.state.loading === false
            ? fakeData?.map((item, index) => {
                return (
                  <div key={index}>
                    <LeaveCard
                      title="Bimaari hu"
                      description="Thandi lad gayi, ghumne gaya tha."
                      status="Approved"
                      from="3 oct 2021"
                      to="31 oct 2021"
                    />
                  </div>
                );
              })
            : null}

          {this.state.data.length === 0 && this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                No Previous Complaints!
              </p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(PreviousLeave);
